import { render } from "./ContactEdit.vue?vue&type=template&id=5bb6331e&ts=true"
import script from "./ContactEdit.vue?vue&type=script&lang=ts"
export * from "./ContactEdit.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Waddecar Media\\Development\\Forms\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__